import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Flex, Image, Text, useColorModeValue } from '@chakra-ui/react';
import { HSeparator } from 'components/separator/Separator';
import demClinicLogo from 'assets/img/brand/dem-clinic-logo.jpg';
import { useAuth } from 'contexts/AuthContext';
import routes from 'routes';
import { firstAllowedAdminPath } from 'constants/permissions';
import { LedgerSystemIndicator } from 'components/ledger/LedgerSystemIndicator';

const BRAND_NAVY = '#1e3a5f';
const BRAND_GREEN = '#48b47b';

export function SidebarBrand() {
  const { user } = useAuth();
  const homePath = firstAllowedAdminPath(user, routes);
  const titleColor = useColorModeValue('navy.700', 'white');
  const subtitleColor = useColorModeValue('gray.500', 'gray.400');
  const logoBg = useColorModeValue(BRAND_NAVY, '#0f2744');

  return (
    <Flex align="center" direction="column" w="100%">
      <Flex
        as={RouterLink}
        to={homePath}
        align="center"
        gap="14px"
        w="100%"
        px="10px"
        py="18px"
        _hover={{ textDecoration: 'none', bg: 'transparent' }}
        _active={{ bg: 'transparent' }}
        _focus={{ boxShadow: 'none' }}
      >
        <Box
          flexShrink={0}
          w="56px"
          h="56px"
          borderRadius="16px"
          bg={logoBg}
          p="7px"
          boxShadow={`0 8px 24px rgba(30, 58, 95, 0.28)`}
          border="2px solid"
          borderColor={useColorModeValue('white', 'whiteAlpha.200')}
        >
          <Image
            src={demClinicLogo}
            alt="DEM CLINIC"
            w="100%"
            h="100%"
            objectFit="contain"
            borderRadius="8px"
          />
        </Box>
        <Flex direction="column" align="flex-start" minW={0} flex="1">
          <Flex align="baseline" gap="6px" flexWrap="wrap">
            <Text
              fontSize="xl"
              fontWeight="800"
              letterSpacing="0.04em"
              lineHeight="1"
              color={titleColor}
            >
              DEM
            </Text>
            <Text
              fontSize="xl"
              fontWeight="800"
              letterSpacing="0.12em"
              lineHeight="1"
              color={BRAND_GREEN}
            >
              CLINIC
            </Text>
          </Flex>
          <Text
            fontSize="xs"
            fontWeight="600"
            letterSpacing="0.22em"
            textTransform="uppercase"
            color={subtitleColor}
            mt="6px"
          >
            CRM
          </Text>
          <Box mt="10px">
            <LedgerSystemIndicator variant="plain" />
          </Box>
        </Flex>
      </Flex>
      <HSeparator mb="20px" w="100%" />
    </Flex>
  );
}

export default SidebarBrand;
